import React, { FC } from 'react'
import SALink from 'components/SALink'
import styles from './Homepage.module.scss'
import useQA from 'hooks/useQA'

const CATEGORIES = [
  {
    categoryName: 'Paintings',
    categoryUrl: 'paintings',
  },
  {
    categoryName: 'Photography',
    categoryUrl: 'photography',
  },
  {
    categoryName: 'Fine Art Prints',
    categoryUrl: 'prints',
  },
  {
    categoryName: 'Sculpture',
    categoryUrl: 'sculpture',
  },
]

const ShopByCategory: FC = () => {
  const { testId } = useQA()
  return (
    <div className={styles.shopByCategory} {...testId('shop-by-category')}>
      <h4 className={styles.title}>Shop by Category</h4>
      <div className={styles.row}>
        {CATEGORIES.map((category, index) => {
          const { categoryName, categoryUrl } = category
          return (
            <SALink href={`/${categoryUrl}`} key={index} className={styles.tile}>
              <p>{categoryName}</p>
            </SALink>
          )
        })}
      </div>
    </div>
  )
}

export default ShopByCategory
